<template>
  <div>
    <single-value-autocomplete
      v-if="!multiple && !returnObject"
      v-model="localValue"
      :list-api="listApi"
      :query-param="queryParam"
      :id-predicate-path="idPredicatePath"
      :show-validation="showValidation"
      :vid="vid"
      :rules="rules"
      :chips="chips"
      :clearable="clearable"
      :deletable-chips="deletableChips"
      :small-chips="smallChips"
      :outlined="outlined"
      :rounded="rounded"
      :dense="dense"
      :single-line="singleLine"
      :label="label"
      :placeholder="placeholder"
      :disabled="disabled"
      :messages="messages"
      :selected-item-to-text="boundSelectedItemToText"
      :item-value="itemValue"
      :multiple="multiple"
      :return-object="returnObject"
      :preload-all-options="preloadAllOptions"
      :counter="counter"
      :search-debounce-time="searchDebounceTime"
      :no-filter="noFilter"
      :shaped="shaped"
      @change="$emit('change', $event)"
      @inputObject="$emit('inputObject', $event)"
    >
      <template v-slot:prepend-item>
        <slot name="prepend-item"></slot>
      </template>
      <template v-slot:item="{ data }">
        <slot name="item" :data="data"></slot>
      </template>
    </single-value-autocomplete>
    <multiple-value-autocomplete
      v-if="multiple && !returnObject"
      v-model="localValue"
      :list-api="listApi"
      :query-param="queryParam"
      :id-predicate-path="idPredicatePath"
      :show-validation="showValidation"
      :vid="vid"
      :rules="rules"
      :chips="chips"
      :clearable="clearable"
      :deletable-chips="deletableChips"
      :small-chips="smallChips"
      :outlined="outlined"
      :rounded="rounded"
      :dense="dense"
      :single-line="singleLine"
      :label="label"
      :placeholder="placeholder"
      :disabled="disabled"
      :messages="messages"
      :selected-item-to-text="boundSelectedItemToText"
      :item-value="itemValue"
      :multiple="multiple"
      :return-object="returnObject"
      :preload-all-options="preloadAllOptions"
      :counter="counter"
      :search-debounce-time="searchDebounceTime"
      :no-filter="noFilter"
      :shaped="shaped"
      @change="$emit('change', $event)"
      @inputObject="$emit('inputObject', $event)"
    >
      <template v-slot:prepend-item>
        <slot name="prepend-item"></slot>
      </template>
      <template v-slot:item="{ data }">
        <slot name="item" :data="data"></slot>
      </template>
    </multiple-value-autocomplete>
    <single-object-autocomplete
      v-if="!multiple && returnObject"
      v-model="localValue"
      :list-api="listApi"
      :query-param="queryParam"
      :id-predicate-path="idPredicatePath"
      :show-validation="showValidation"
      :vid="vid"
      :rules="rules"
      :chips="chips"
      :clearable="clearable"
      :deletable-chips="deletableChips"
      :small-chips="smallChips"
      :outlined="outlined"
      :rounded="rounded"
      :dense="dense"
      :single-line="singleLine"
      :label="label"
      :placeholder="placeholder"
      :disabled="disabled"
      :messages="messages"
      :selected-item-to-text="boundSelectedItemToText"
      :item-value="itemValue"
      :multiple="multiple"
      :return-object="returnObject"
      :preload-all-options="preloadAllOptions"
      :counter="counter"
      :search-debounce-time="searchDebounceTime"
      :no-filter="noFilter"
      :shaped="shaped"
      @change="$emit('change', $event)"
      @inputObject="$emit('inputObject', $event)"
    >
      <template v-slot:prepend-item>
        <slot name="prepend-item"></slot>
      </template>
      <template v-slot:item="{ data }">
        <slot name="item" :data="data"></slot>
      </template>
    </single-object-autocomplete>
    <multiple-object-autocomplete
      v-if="multiple && returnObject"
      v-model="localValue"
      :list-api="listApi"
      :query-param="queryParam"
      :id-predicate-path="idPredicatePath"
      :show-validation="showValidation"
      :vid="vid"
      :rules="rules"
      :chips="chips"
      :clearable="clearable"
      :deletable-chips="deletableChips"
      :small-chips="smallChips"
      :outlined="outlined"
      :rounded="rounded"
      :dense="dense"
      :single-line="singleLine"
      :label="label"
      :placeholder="placeholder"
      :disabled="disabled"
      :messages="messages"
      :selected-item-to-text="boundSelectedItemToText"
      :item-value="itemValue"
      :multiple="multiple"
      :return-object="returnObject"
      :preload-all-options="preloadAllOptions"
      :counter="counter"
      :search-debounce-time="searchDebounceTime"
      :no-filter="noFilter"
      :shaped="shaped"
      @change="$emit('change', $event)"
      @inputObject="$emit('inputObject', $event)"
    >
      <template v-slot:prepend-item>
        <slot name="prepend-item"></slot>
      </template>
      <template v-slot:item="{ data }">
        <slot name="item" :data="data"></slot>
      </template>
    </multiple-object-autocomplete>
  </div>
</template>

<script lang="js">
import SingleValueAutocomplete from "./SingleValueAutocomplete";
import MultipleValueAutocomplete from "./MultipleValueAutocomplete";
import SingleObjectAutocomplete from "./SingleObjectAutocomplete";
import MultipleObjectAutocomplete from "./MultipleObjectAutocomplete";
import LocalValueInput from "./LocalValueInput";
import AutocompleteProps from "./AutocompleteProps";

export default {
  components: {
    MultipleObjectAutocomplete,
    SingleObjectAutocomplete,
    MultipleValueAutocomplete,
    SingleValueAutocomplete
  },
  mixins: [LocalValueInput, AutocompleteProps],
  computed: {
    messages() {
      return this.disabled ? "Brak możliwości zmiany wartości!" : "";
    }
  },
  data() {
    return {
      boundSelectedItemToText: this.selectedItemToText.bind(this)
    };
  }
};
</script>

<style scoped></style>
